import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  globalDataFetched: boolean = false;

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {
    this.authService
      .getProfile()
      .pipe(
        finalize(() => {
          this.globalDataFetched = true;
        })
      )
      .subscribe(
        () => {},
        (error) => {
          this.router.navigateByUrl('/login');
        }
      );
  }
}
